/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import DataVaxiomOtherProfessionalsEdit from 'DesignSystem/DataVaxiomOtherProfessionalsEdit/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsRelationshipsItem/Edit/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let professionalValueData = fromData.useDataValue({ viewPath,
context: 'professional',
})
  return (<React.Fragment
>
<DataVaxiomOtherProfessionalsEdit
  viewPath={`${viewPath}/DataVaxiomOtherProfessionalsEdit`}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 data="professional"
 value={professionalValueData}
/>
{children}
</React.Fragment>)
}